import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription, filter } from 'rxjs';
import { excludeRoutesArray } from 'src/app/core/constants/exclude-routes';

// Product area by first URL segment. assets/scss/bootstrap.scss loads the bus, cab and
// holiday stylesheets only under body[data-product=...], so their rules (which reuse the
// flight class names) stop leaking into flight pages. Anything unlisted is "flight",
// whose stylesheet stays the app-wide base.
const PRODUCT_BY_PREFIX: [RegExp, string][] = [
  [/^\/bus/, 'bus'],
  [/^\/transfers/, 'cab'],
  [/^\/holiday/, 'holiday'],
];

@Component({
  selector: 'app-horizontal',
  templateUrl: './horizontal.component.html',
  styleUrls: ['./horizontal.component.scss'],
})

/**
 * Horizontal-layout component
 */
export class HorizontalComponent implements OnInit, AfterViewInit, OnDestroy {
  isCondensed = false;
  private routeSub?: Subscription;

  constructor(private router: Router) {}

  ngOnInit() {
    document.body.setAttribute('data-layout', 'horizontal');
    this.setProductArea(this.router.url);
    this.routeSub = this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event) => this.setProductArea(event.urlAfterRedirects));
  }

  ngOnDestroy() {
    this.routeSub?.unsubscribe();
    document.body.removeAttribute('data-product');
  }

  // On <body>, not the layout wrapper: dialogs render in the CDK overlay container,
  // which sits outside the layout but inside body, and need the same product styles.
  private setProductArea(url: string) {
    const match = PRODUCT_BY_PREFIX.find(([prefix]) => prefix.test(url));
    document.body.setAttribute('data-product', match ? match[1] : 'flight');
  }

  ngAfterViewInit() {}

  /**
   * on settings button clicked from topbar
   */
  onSettingsButtonClicked() {
    document.body.classList.toggle('right-bar-enabled');
  }

  /**
   * Mobile Toggle Menu
   */
  onToggleMobileMenu() {
    const element = document.getElementById('topnav-menu-content');
    element?.classList.toggle('show');
  }

  excludeRoutes():boolean {
    let currentRoute=this.router.url
    if (excludeRoutesArray.includes(currentRoute)) {
      return true
    }

    return false
  }
}
